var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageRemboursementAides(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 124,
    viewBox: "0 0 128 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_668_21151)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.5,
    cy: 119,
    rx: 58.5,
    ry: 3,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0646 31.3902C55.353 33.1329 51.1637 33.0129 46.7749 31.189C42.386 29.3652 39.4011 26.4737 40.1127 24.731C40.2801 24.3286 40.7567 22.8195 41.2333 22.6118C42.869 21.9141 45.9828 23.4816 49.3541 24.8835C52.4936 26.1816 56.0839 27.0286 56.641 28.7454C56.9758 29.7903 56.2674 30.8937 56.0646 31.3902Z",
    fill: "#ED8C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.6414 28.7457C56.9087 30.112 56.3194 30.7675 56.065 31.3906C55.8106 32.0137 55.0668 32.4226 54.0268 32.5654C53.8967 32.5877 53.7656 32.6028 53.6339 32.6108C52.8364 32.6581 52.0361 32.6156 51.2479 32.4842C51.1352 32.4842 51.0225 32.4485 50.9066 32.4291C49.9813 32.2617 49.0697 32.0252 48.1792 31.7216L47.8572 31.6113C47.4998 31.4847 47.1327 31.3452 46.7657 31.1926C46.3986 31.0401 46.0508 30.8681 45.7063 30.7156L45.41 30.5728C44.5983 30.1682 43.8161 29.7063 43.0691 29.1903L42.8051 29.0021C42.153 28.5376 41.5556 27.9997 41.0244 27.3989C40.9439 27.3081 40.8698 27.2204 40.799 27.1296C40.1067 26.2469 39.833 25.4031 40.1067 24.7313C40.287 24.2997 40.6734 22.8231 41.2273 22.6089C41.9084 22.4155 42.6294 22.4155 43.3106 22.6089L43.6326 22.6868C45.2426 23.1022 47.2712 24.0271 49.3417 24.8871C51.7824 25.9029 54.6708 26.9576 56.0876 28.1745C56.1719 28.2461 56.2525 28.3219 56.3291 28.4017C56.4421 28.5078 56.5465 28.6228 56.6414 28.7457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.7928 22.4077L43.6447 22.6803L41.0301 27.3957C40.9496 27.3048 40.8755 27.2172 40.8047 27.1263L43.3163 22.6024L43.5127 22.252L43.7928 22.4077Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.7697 24.3319L43.0746 29.1998L42.8105 29.0116L45.4896 24.1826L45.7697 24.3319Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.7264 27.1232L48.1794 31.7217L47.8574 31.6114L50.4334 26.9512L50.7264 27.1232Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.4203 25.8248L45.7123 30.7154L45.416 30.5726L48.1401 25.6528L48.4203 25.8248Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.7302 28.0124L51.2476 32.4843C51.1349 32.4843 51.0222 32.4486 50.9062 32.4292L53.4468 27.8501L53.7302 28.0124Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.6214 29.8721C55.9098 31.6148 51.7721 31.5467 47.38 29.7196C42.988 27.8925 40.0062 25.0042 40.7211 23.2615C41.4359 21.5188 45.5704 21.5902 49.9625 23.4141C54.3546 25.2379 57.3331 28.1197 56.6214 29.8721Z",
    fill: "#ED8C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.1285 29.239C54.6262 30.4689 51.3998 30.2969 47.9254 28.8528C44.451 27.4086 42.0424 25.2376 42.5448 24.0076C43.0471 22.7777 46.2735 22.9497 49.7511 24.3938C53.2287 25.8379 55.6341 28.009 55.1285 29.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2575 15.6382C79.4038 17.1278 77.2206 20.7333 73.4629 23.6638C69.7051 26.5942 65.7349 27.7625 64.5918 26.26C64.3277 25.916 63.2587 24.7639 63.3231 24.2252C63.5388 22.45 66.4336 20.5094 69.3187 18.2572C72.0042 16.1607 74.5126 13.4412 76.2675 13.8079C77.3333 14.0448 77.9322 15.2164 78.2575 15.6382Z",
    fill: "#ED8C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.2666 13.8208C77.5772 14.2686 77.8476 15.1189 78.2566 15.6381C78.6655 16.1574 78.6494 17.0239 78.2566 18.0072C78.2115 18.1273 78.1568 18.2473 78.0988 18.3707C77.746 19.0921 77.314 19.7714 76.8108 20.3957C76.7432 20.4866 76.6691 20.5742 76.5951 20.665C75.9895 21.3929 75.3308 22.0742 74.6244 22.7031L74.3765 22.9205C74.0899 23.1704 73.7872 23.4203 73.4749 23.6637C73.1625 23.9071 72.8502 24.1375 72.5346 24.3549C72.4477 24.4198 72.3543 24.4815 72.2674 24.5431C71.515 25.0518 70.7273 25.5051 69.9103 25.8996C69.8105 25.9516 69.7139 25.9938 69.6205 26.0392C68.8946 26.3776 68.1331 26.6324 67.3504 26.7986C67.2345 26.8245 67.1218 26.844 67.0091 26.8602C65.9047 27.0258 65.0417 26.8602 64.6006 26.2729C64.3172 25.9029 63.2385 24.8287 63.3319 24.2413C63.5003 23.5469 63.8584 22.914 64.3655 22.4142C64.4363 22.3331 64.5136 22.252 64.5941 22.1676C65.7565 20.9539 67.5565 19.6525 69.3275 18.2733C71.4173 16.6507 73.7615 14.6418 75.5099 14.0123C75.6155 13.9732 75.723 13.9396 75.8319 13.9117C75.9744 13.8707 76.1197 13.8404 76.2666 13.8208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.4241 21.9014L64.5851 22.1675L67.3414 26.7985C67.2255 26.8244 67.1128 26.8439 67.0001 26.8601L64.3565 22.4076L64.1504 22.0831L64.4241 21.9014Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.0621 21.1289L69.9021 25.8994C69.8023 25.9514 69.7057 25.9935 69.6123 26.039L66.7852 21.2944L67.0621 21.1289Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.9273 18.189L74.616 22.7064L74.3681 22.9238L71.6504 18.3545L71.9273 18.189Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.6669 19.5552L72.5262 24.3549C72.4393 24.4198 72.3459 24.4815 72.259 24.5431L69.3867 19.7207L69.6669 19.5552Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.1871 15.9985L76.8017 20.3959C76.7341 20.4867 76.66 20.5743 76.586 20.6652L73.9102 16.1673L74.1871 15.9985Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.4872 22.3897C76.2424 19.4582 78.3588 15.8745 77.2143 14.3853C76.0698 12.8961 72.0977 14.0652 68.3425 16.9967C64.5872 19.9282 62.4708 23.5119 63.6153 25.0012C64.7598 26.4904 68.7319 25.3212 72.4872 22.3897Z",
    fill: "#ED8C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.0226 21.4865C74.9947 19.1663 76.7482 16.432 75.9391 15.3792C75.13 14.3264 72.0646 15.3538 69.0925 17.674C66.1203 19.9941 64.3669 22.7285 65.176 23.7813C65.9851 24.8341 69.0504 23.8067 72.0226 21.4865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7145 8.66098C62.3475 10.7964 57.5947 11.6985 52.2109 10.725C46.8271 9.75139 42.7666 7.24281 43.1434 5.10743C43.2303 4.6109 43.3817 2.8033 43.8872 2.44307C45.5584 1.25531 49.4417 2.24836 53.5762 2.98828C57.4402 3.67952 61.668 3.73468 62.7145 5.52931C63.3489 6.6327 62.8208 8.05088 62.7145 8.66098Z",
    fill: "#ED8C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.7138 5.53241C63.3578 7.00576 62.8458 7.88522 62.7138 8.6511C62.5818 9.41698 61.8444 10.0563 60.711 10.4782C60.5725 10.5334 60.4276 10.5788 60.2795 10.6242C59.3929 10.8754 58.4815 11.0266 57.5618 11.0753C57.4298 11.0753 57.301 11.0753 57.1658 11.098C56.0824 11.1382 54.9975 11.098 53.92 10.978L53.5433 10.9293C53.1086 10.8741 52.661 10.8092 52.2134 10.7281C51.7658 10.6469 51.3311 10.5561 50.9029 10.4555C50.7805 10.4295 50.6581 10.3971 50.5358 10.3678C49.5241 10.1161 48.5319 9.79069 47.5669 9.39427C47.4478 9.34883 47.3351 9.29691 47.2224 9.25147C46.3755 8.88815 45.5719 8.42984 44.8267 7.88522C44.714 7.80409 44.611 7.72296 44.5047 7.63858C43.5065 6.81753 42.9945 5.93482 43.1394 5.11377C43.236 4.58155 43.3133 2.84209 43.88 2.44942C44.4468 2.05674 45.2582 1.93342 46.2242 1.93018H46.6106C48.5426 1.99508 51.0317 2.53704 53.5722 2.99137C56.5668 3.53009 60.0734 4.00065 61.9603 5.01966C62.071 5.07878 62.1785 5.14378 62.2823 5.21437C62.4342 5.3089 62.5784 5.41524 62.7138 5.53241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.7173 1.59928L46.6143 1.94003L44.824 7.89183C44.7113 7.8107 44.6082 7.72957 44.502 7.6452L46.2214 1.93679L46.3567 1.49219L46.7173 1.59928Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.4084 3.26056L47.5633 9.39085C47.4441 9.34541 47.3315 9.29349 47.2188 9.24805L49.0541 3.14697L49.4084 3.26056Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.6662 5.18163L53.9178 10.9874L53.541 10.9387L55.3088 5.07129L55.6662 5.18163Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.7582 4.29261L50.9003 10.4586C50.7779 10.4326 50.6556 10.4002 50.5332 10.371L52.4008 4.17578L52.7582 4.29261Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.2616 5.43522L57.5582 11.0852C57.4262 11.0852 57.2973 11.0852 57.1621 11.1079L58.9041 5.32812L59.2616 5.43522Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.965 6.79625C63.3419 4.66111 59.2816 2.14723 53.896 1.18136C48.5104 0.215484 43.8389 1.16337 43.4619 3.29852C43.0849 5.43367 47.1452 7.94755 52.5308 8.91342C57.9165 9.87929 62.588 8.9314 62.965 6.79625Z",
    fill: "#ED8C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.1317 6.47001C61.398 4.96129 58.1593 3.11866 53.8977 2.35437C49.6361 1.59009 45.9655 2.19358 45.6991 3.7023C45.4327 5.21102 48.6715 7.05366 52.9331 7.81794C57.1946 8.58222 60.8653 7.97873 61.1317 6.47001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8257 63.1784L57.6887 65.1255C56.5182 65.195 55.3696 65.4764 54.298 65.9563L18.3049 82.1826C17.6734 82.4624 17.1562 82.9521 16.8397 83.5699C16.5233 84.1877 16.4267 84.8962 16.5661 85.5771L22.5134 113.924C22.614 114.381 22.8168 114.808 23.1063 115.174C23.3958 115.539 23.7644 115.833 24.1838 116.033C24.6033 116.232 25.0626 116.333 25.5265 116.326C25.9904 116.32 26.4467 116.206 26.8604 115.995L62.3867 98.1201L95.192 97.0134C95.5957 97.0026 95.9925 96.9052 96.3559 96.7277C96.7193 96.5502 97.0411 96.2968 97.2997 95.9842C97.5583 95.6717 97.748 95.3072 97.8559 94.915C97.9639 94.5228 97.9877 94.1119 97.9258 93.7098L93.537 66.5664C93.3083 65.1645 92.2522 63.1362 90.8257 63.1784Z",
    fill: "#80B9F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M90.8257 63.1784L57.6887 65.1255C56.5182 65.195 55.3696 65.4764 54.298 65.9563L18.3049 82.1826C17.6734 82.4624 17.1562 82.9521 16.8397 83.5699C16.5233 84.1877 16.4267 84.8962 16.5661 85.5771L22.5134 113.924C22.614 114.381 22.8168 114.808 23.1063 115.174C23.3958 115.539 23.7644 115.833 24.1838 116.033C24.6033 116.232 25.0626 116.333 25.5265 116.326C25.9904 116.32 26.4467 116.206 26.8604 115.995L62.3867 98.1201L95.192 97.0134C95.5957 97.0026 95.9925 96.9052 96.3559 96.7277C96.7193 96.5502 97.0411 96.2968 97.2997 95.9842C97.5583 95.6717 97.748 95.3072 97.8559 94.915C97.9639 94.5228 97.9877 94.1119 97.9258 93.7098L93.537 66.5664C93.3083 65.1645 92.2522 63.1362 90.8257 63.1784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3136 44.7203L6.92383 60.876L38.1305 94.9954L55.5203 78.8397L24.3136 44.7203Z",
    fill: "#0073E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.5149 78.8428L38.1237 94.9977L6.92188 60.8803L18.3336 50.2781L24.3131 44.7222L25.3081 45.8126L55.5149 78.8428Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4243 46.8062L9.08008 61.0615L38.2701 92.9761L53.6144 78.7208L24.4243 46.8062Z",
    stroke: "#0073E0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8007 73.6697C36.5607 72.0346 36.3381 68.9058 34.3035 66.6813C32.2689 64.4568 29.1928 63.979 27.4328 65.6141C25.6728 67.2492 25.8954 70.378 27.93 72.6025C29.9646 74.827 33.0407 75.3048 34.8007 73.6697Z",
    fill: "#0073E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.9406 81.1507L31.7614 83.3023L18.334 50.2785L24.3135 44.7227L25.3085 45.8131L37.9406 81.1507Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1446 31.3534L16.9102 39.4785L32.6048 83.1033L54.8393 74.9781L39.1446 31.3534Z",
    fill: "#0073E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.1446 31.3534L16.9102 39.4785L32.6048 83.1033L54.8393 74.9781L39.1446 31.3534Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4452 33.3208L18.8262 40.4902L33.5067 81.296L53.1257 74.1266L38.4452 33.3208Z",
    stroke: "#0073E0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7156 62.1356C39.9659 61.3132 40.9607 58.3409 39.9374 55.4967C38.9142 52.6525 36.2604 51.0134 34.0101 51.8357C31.7598 52.6581 30.7651 55.6304 31.7883 58.4746C32.8116 61.3188 35.4653 62.9579 37.7156 62.1356Z",
    fill: "#0073E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0404 64.3301L58.3574 66.1864C57.1988 66.2504 56.0621 66.5311 55.0054 67.014L19.5403 83.1494C18.9156 83.4339 18.406 83.9248 18.0957 84.5409C17.7853 85.1569 17.6929 85.8613 17.8337 86.5374L23.781 114.898C23.8768 115.351 24.0745 115.777 24.359 116.142C24.6434 116.506 25.007 116.8 25.4218 117.001C25.8366 117.202 26.2916 117.304 26.7518 117.3C27.212 117.296 27.6652 117.186 28.0765 116.978L63.0779 99.2037L95.4325 98.1717C95.833 98.1589 96.2262 98.0602 96.5859 97.8821C96.9456 97.704 97.2634 97.4506 97.5182 97.1388C97.773 96.8271 97.9588 96.4641 98.0634 96.0742C98.1679 95.6843 98.1887 95.2764 98.1244 94.8778L93.7226 67.7377C93.494 66.3227 92.4507 64.2912 91.0404 64.3301Z",
    fill: "#C3DAF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.6875 71.1516L87.7305 69.4121",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.3301 71.8818L61.4531 95.5982",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.1719 93.2939L25.7847 111.536C25.7847 111.536 28.5539 104.299 22.1719 93.2939Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.6445 93.5081C22.7701 93.8326 54.7351 80.0078 54.7351 80.0078C54.8217 83.1421 54.0441 86.2393 52.4888 88.9549C50.9335 91.6705 48.6614 93.8982 45.9251 95.3903C36.3038 100.826 22.6445 93.5081 22.6445 93.5081Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8787 94.0468C44.6434 94.0468 45.2633 93.422 45.2633 92.6513C45.2633 91.8806 44.6434 91.2559 43.8787 91.2559C43.114 91.2559 42.4941 91.8806 42.4941 92.6513C42.4941 93.422 43.114 94.0468 43.8787 94.0468Z",
    fill: "#0073E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.752 80.0078C54.752 80.0078 58.7158 86.0213 57.7562 96.2633L54.752 80.0078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.6426 86.1281L21.38 85.8003",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.9102 85.1189L52.7596 71.8198",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5.2 5.2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.5254 71.4791L54.2596 71.1514",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6289 76.4839L88.6719 74.7412",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.8906 83.1333L89.9336 81.3906",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7865 35.8955C83.7865 35.8955 83.0813 43.4667 80.2895 44.119C78.5607 44.4953 76.7582 44.3137 75.1375 43.5998L72.8674 41.8408L71.7598 45.7351C71.7598 45.7351 72.9705 47.3935 75.4982 46.2446C75.4982 46.2446 80.0062 48.2437 82.4985 46.2446C84.9907 44.2456 85.7893 38.7611 85.7893 38.7611L83.7865 35.8955Z",
    fill: "#B97964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0317 32.2282C86.0317 32.2282 84.0836 28.8823 84.9691 22.8169C85.8546 16.7516 90.9003 16.0019 92.8484 16.44C94.7965 16.8781 96.3904 18.7636 97.7171 22.3529C99.0437 25.9421 99.5331 26.8768 101.745 26.2472C103.957 25.6176 109.844 23.651 111.483 25.4002C111.954 25.878 112.301 26.4655 112.494 27.1107C112.687 27.756 112.719 28.4391 112.587 29.0998C112.587 29.0998 120.775 27.0942 120.067 34.4544C119.359 41.8147 107.541 48.6849 96.3003 41.4123C85.0592 34.1396 86.0317 32.2282 86.0317 32.2282Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9399 50.0413C85.9399 50.0413 83.7149 69.3279 83.7889 78.3724C83.863 87.417 87.0508 108.732 87.0508 108.732H90.9824C90.9824 108.732 90.464 91.6877 90.538 85.856C90.6121 80.0243 91.6489 70.3761 91.6489 70.3761C91.6489 70.3761 92.908 79.0474 94.3924 82.111C95.8768 85.1745 104.11 96.0169 109.823 99.3822L112.492 96.9126C112.492 96.9126 106.558 89.5134 104.333 85.8495C102.108 82.1856 100.108 81.1471 99.29 74.3321C98.4721 67.517 99.8857 56.6162 97.5126 50.0381L85.9399 50.0413Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.6501 70.3763L89.9402 58.1514C89.9402 58.1514 88.5911 65.4986 91.2476 74.4718L91.6501 70.3763Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8594 109.812L87.9914 113.6L90.6286 113.82L90.7606 113.467V109.546L87.8594 109.812Z",
    fill: "#B97964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6074 108.372L86.8489 109.79L91.3762 109.9L91.6628 108.196L86.6074 108.372Z",
    fill: "#0073E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.584 99.6448L112.78 95.7051L113.704 97.1882L110.101 100.511L108.584 99.6448Z",
    fill: "#0073E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.605 99.6452L113.375 101.995L115.152 99.8886L112.879 97.5195L110.605 99.6452Z",
    fill: "#B97964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.691 99.7263L117.366 100.765C117.442 100.812 117.507 100.876 117.556 100.951C117.606 101.027 117.638 101.112 117.651 101.201C117.664 101.291 117.658 101.382 117.633 101.468C117.607 101.555 117.563 101.635 117.504 101.703C116.29 103.085 113.189 106.596 112.88 106.843C112.497 107.168 112.033 106.622 111.914 106.136C111.914 106.136 112.793 104.961 112.88 104.208C112.917 103.627 112.917 103.043 112.88 102.462C112.873 102.316 112.922 102.174 113.015 102.063L114.886 99.8496C114.983 99.7343 115.118 99.6582 115.266 99.6355C115.414 99.6128 115.565 99.6451 115.691 99.7263Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2721 113.925L91.6198 115.872C91.6358 115.961 91.6323 116.052 91.6094 116.14C91.5866 116.227 91.545 116.309 91.4876 116.378C91.4302 116.448 91.3584 116.504 91.2773 116.543C91.1961 116.581 91.1075 116.601 91.0177 116.602C89.1855 116.602 84.523 116.621 84.1333 116.557C83.6471 116.475 83.7341 115.774 84.0206 115.366C84.0206 115.366 85.4729 115.242 86.0814 114.798C86.5341 114.44 86.9642 114.054 87.3694 113.642C87.473 113.54 87.611 113.481 87.7558 113.477L90.6377 113.409C90.7874 113.403 90.934 113.452 91.0506 113.547C91.1671 113.642 91.2458 113.776 91.2721 113.925Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9354 39.3451L101.954 36.5022C101.954 36.5022 100.885 32.1925 99.3007 31.9783C97.7165 31.7641 89.8532 30.2551 84.8526 31.9783C84.8526 31.9783 83.0558 32.4943 82.502 37.5796L84.64 38.2676C84.64 38.2676 85.4064 47.7892 85.8797 49.2561H97.2914C97.2914 49.2561 97.4202 41.0683 97.9354 39.3451Z",
    fill: "#0073E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8018 38.7318C98.8018 38.7318 100.325 43.1129 100.595 45.469C100.595 45.469 96.9761 44.0151 96.0423 43.3498L95.3339 40.7861L92.9382 39.608L92.2266 41.5552L94.2262 44.054C94.2262 44.054 99.6776 49.1945 102.44 48.0197C105.203 46.845 101.349 36.9404 101.349 36.9404L98.8018 38.7318Z",
    fill: "#B97964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.577 19.5489C88.577 19.5489 87.1827 22.3528 87.289 24.6342C87.3952 26.9156 88.5383 27.847 90.7118 28.1683C90.7118 28.1683 91.6392 31.089 89.2049 31.3843C89.0181 31.4071 88.9537 32.1502 88.9666 32.2703C89.031 32.7441 89.4979 33.0037 89.9326 33.1141C90.3905 33.2162 90.8579 33.2685 91.3269 33.2698C91.8193 33.2869 92.3092 33.1909 92.7593 32.9891C93.2095 32.7873 93.6083 32.4849 93.9254 32.1048C93.9769 32.0431 94.4664 31.4136 94.4664 31.4136C94.4664 31.4136 93.3039 30.8327 93.7129 27.0292C94.2676 26.6652 94.6937 26.1336 94.93 25.5104C95.1521 25.3916 95.3485 25.2294 95.5077 25.0333C95.667 24.8372 95.7858 24.611 95.8574 24.3681C96.0313 23.6087 95.3647 22.5572 94.1476 23.6087C94.1476 23.6087 91.8549 22.4404 90.9855 18.3481C90.3409 19.0119 89.4916 19.4352 88.577 19.5489Z",
    fill: "#B97964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2315 24.011L89.4279 22.5117L88.375 23.6865C88.4836 23.803 88.6173 23.8929 88.7658 23.9491C88.9143 24.0054 89.0736 24.0266 89.2315 24.011Z",
    fill: "#A24E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8438 25.1082C89.8438 25.1082 90.9546 25.2802 91.4892 24.563",
    stroke: "#222221",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9551 20.4123C91.2073 20.3401 91.4741 20.3378 91.7275 20.4058C91.9808 20.4738 92.2113 20.6095 92.3944 20.7985",
    stroke: "#222221",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0321 20.0878C89.0321 20.0878 88.3881 19.9872 88.1016 20.3539",
    stroke: "#222221",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4014 22.3856C91.3725 22.6128 91.2276 22.7783 91.0794 22.7588C90.9313 22.7393 90.8315 22.5414 90.8605 22.3142C90.8895 22.087 91.0344 21.9215 91.1825 21.941C91.3306 21.9605 91.4304 22.1584 91.4014 22.3856Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8318 21.883C88.8609 21.6573 88.763 21.4584 88.6131 21.4388C88.4632 21.4192 88.3181 21.5863 88.289 21.812C88.2599 22.0377 88.3578 22.2366 88.5077 22.2562C88.6576 22.2759 88.8027 22.1088 88.8318 21.883Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1865 21.9407L90.6777 21.7168C90.6844 21.7729 90.7056 21.8263 90.739 21.8717C90.7725 21.917 90.8172 21.9528 90.8686 21.9754C90.92 21.9981 90.9763 22.0068 91.0321 22.0007C91.0879 21.9946 91.1411 21.9739 91.1865 21.9407Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6611 21.4603L88.1523 21.2363C88.159 21.2925 88.1802 21.3458 88.2136 21.3912C88.2471 21.4366 88.2918 21.4723 88.3432 21.495C88.3946 21.5176 88.4509 21.5263 88.5067 21.5202C88.5625 21.5141 88.6157 21.4934 88.6611 21.4603Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4805 48.7497V50.103L97.8453 50.2068L97.5136 48.5972L85.4805 48.7497Z",
    fill: "#0073E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M85.4805 48.7497V50.103L97.8453 50.2068L97.5136 48.5972L85.4805 48.7497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6317 42.1813L78.8311 66.021C78.605 66.8193 78.1467 67.5311 77.5154 68.0644C76.884 68.5978 76.1086 68.9282 75.2891 69.0131C74.7674 69.0634 74.2411 69.0149 73.7371 68.8703L60.7379 65.1025C59.6871 64.797 58.7994 64.0839 58.2694 63.1197C57.7394 62.1554 57.6104 61.0187 57.9108 59.9588L64.7146 36.1127C65.0185 35.055 65.7259 34.1619 66.682 33.629C67.638 33.0962 68.7647 32.967 69.8151 33.2698L82.8239 37.0343C83.8724 37.3432 84.7566 38.0584 85.2829 39.0231C85.8092 39.9879 85.9346 41.1235 85.6317 42.1813Z",
    fill: "#0073E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.6317 42.1813L78.8311 66.021C78.605 66.8193 78.1467 67.5311 77.5154 68.0644C76.884 68.5978 76.1086 68.9282 75.2891 69.0131C74.7674 69.0634 74.2411 69.0149 73.7371 68.8703L60.7379 65.1025C59.6871 64.797 58.7994 64.0839 58.2694 63.1197C57.7394 62.1554 57.6104 61.0187 57.9108 59.9588L64.7146 36.1127C65.0185 35.055 65.7259 34.1619 66.682 33.629C67.638 33.0962 68.7647 32.967 69.8151 33.2698L82.8239 37.0343C83.8724 37.3432 84.7566 38.0584 85.2829 39.0231C85.8092 39.9879 85.9346 41.1235 85.6317 42.1813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5015 42.4637L77.7009 66.3066C77.5289 66.9136 77.2217 67.4729 76.8026 67.942C76.3835 68.4111 75.8636 68.7774 75.2827 69.0132C74.761 69.0635 74.2346 69.015 73.7306 68.8704L60.7379 65.1026C59.6871 64.7971 58.7994 64.084 58.2694 63.1198C57.7394 62.1555 57.6104 61.0188 57.9108 59.9589L64.7146 36.1128C64.8868 35.5067 65.1942 34.9483 65.6133 34.4803C66.0324 34.0123 66.5522 33.6472 67.1328 33.4127C67.6545 33.3592 68.1815 33.4077 68.6849 33.5555L81.6679 37.3362C82.7168 37.6399 83.6037 38.3497 84.1347 39.3106C84.6657 40.2715 84.7976 41.4051 84.5015 42.4637Z",
    fill: "#0073E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.5015 42.4637L77.7009 66.3066C77.5289 66.9136 77.2217 67.4729 76.8026 67.942C76.3835 68.4111 75.8636 68.7774 75.2827 69.0132C74.761 69.0635 74.2346 69.015 73.7306 68.8704L60.7379 65.1026C59.6871 64.7971 58.7994 64.084 58.2694 63.1198C57.7394 62.1555 57.6104 61.0188 57.9108 59.9589L64.7146 36.1128C64.8868 35.5067 65.1942 34.9483 65.6133 34.4803C66.0324 34.0123 66.5522 33.6472 67.1328 33.4127C67.6545 33.3592 68.1815 33.4077 68.6849 33.5555L81.6679 37.3362C82.7168 37.6399 83.6037 38.3497 84.1347 39.3106C84.6657 40.2715 84.7976 41.4051 84.5015 42.4637Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2177 44.491L64.8262 44.0957L59.8175 62.0062L61.2091 62.4015L66.2177 44.491Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2074 62.9704L61.8164 62.5647L66.8235 44.6606L68.2113 45.0631L63.2074 62.9704Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2289 63.5545L63.8379 63.1521L68.845 45.248L70.236 45.6505L65.2289 63.5545Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.3349 47.9968L76.9434 47.6016L71.9347 65.5121L73.3263 65.9074L78.3349 47.9968Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1583 42.9343L77.4821 45.365L76.6577 45.1313C76.2584 45.0171 75.9203 44.7481 75.7175 44.3831C75.5147 44.0181 75.4638 43.5869 75.5758 43.1842L76.0266 41.5615L77.6914 42.0418C77.8706 42.0979 78.0205 42.2234 78.108 42.3907C78.1955 42.558 78.2136 42.7535 78.1583 42.9343Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7624 41.7435L76.0977 41.2632L76.5968 39.4848C76.6525 39.2853 76.7467 39.0988 76.8739 38.936C77.0012 38.7732 77.1591 38.6373 77.3385 38.536C77.5179 38.4348 77.7154 38.3701 77.9196 38.3458C78.1239 38.3215 78.3309 38.338 78.5288 38.3944L79.3853 38.6378L78.6382 41.2567C78.6134 41.3473 78.5709 41.4319 78.5132 41.5057C78.4555 41.5794 78.3837 41.6408 78.3021 41.6861C78.2205 41.7315 78.1307 41.7599 78.038 41.7698C77.9453 41.7796 77.8516 41.7707 77.7624 41.7435Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3389 42.5284L81.0133 43.012L80.569 44.5989C80.514 44.7989 80.4203 44.9859 80.2932 45.1492C80.1661 45.3124 80.0082 45.4487 79.8285 45.5501C79.6489 45.6514 79.4511 45.716 79.2466 45.7399C79.0421 45.7638 78.8349 45.7466 78.637 45.6893L77.7676 45.4427L78.4599 43.0152C78.4854 42.9248 78.5285 42.8404 78.5866 42.7668C78.6448 42.6933 78.7168 42.6321 78.7986 42.5869C78.8803 42.5416 78.9702 42.5131 79.0629 42.5031C79.1557 42.4931 79.2495 42.5017 79.3389 42.5284Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6076 40.9061L81.1021 42.7104L79.4277 42.2269C79.2484 42.1741 79.097 42.0521 79.0066 41.8874C78.9161 41.7226 78.8939 41.5286 78.9447 41.3474L79.6917 38.7285L80.5257 38.9654C80.7232 39.0212 80.9078 39.1157 81.0691 39.2435C81.2303 39.3712 81.365 39.5297 81.4655 39.7099C81.5659 39.8901 81.6302 40.0885 81.6546 40.2937C81.679 40.499 81.663 40.7071 81.6076 40.9061Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_668_21151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageRemboursementAides);
export default __webpack_public_path__ + "static/media/image_remboursement_aides.cc60d8241be9d841dd3bab1201eeba09.svg";
export { ForwardRef as ReactComponent };